<!-- 教师备授课活跃排行Top5 -->
<template>
    <div class="active-school-rank">
        <div class="active-school-rank-top">
            <div class="title">活跃教师top5</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="active-school-rank-content">
            <div class="active-school-rank-content-tips">
                <div class="color" style="background-color: #2B7FFF"></div>
                <div class="name">建设</div>
                <div class="color" style="background-color: #27CDE6"></div>
                <div class="name">引用</div>
            </div>
            <div class="active-school-rank-list">
                <div class="active-school-rank-li" v-for="(item,index) in schoolList" :key="item.schoolId">
                    <div class="rank">NO.{{ index + 1 }}</div>
                    <div class="school-name">{{ item.schoolName }}</div>
                    <div class="progress">
                        <div class="top">
                            <el-progress class="rank-progress" :color="'#2B7FFF'"   :percentage="item.buildProgress" :show-text="false" :stroke-width="16" />
                            <div class="number">{{ item.buildNumber }}</div>
                        </div>
                        <div class="bottom">
                            <el-progress class="rank-progress" :color="'#27CDE6'"    :percentage="item.quoteProgress" :show-text="false" :stroke-width="16" />
                            <div class="number">{{ item.quoteNumber }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div> 
  </template>
  
  <script>
  export default {
    name: 'active-school-rank',
    components: {
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            //是否选中授课
            isActiveLectures:false,
            rankList:[], 
            schoolList:[
                {
                    schoolName:"林子书",
                    schoolId:'1',
                    buildNumber:1928,
                    quoteNumber:1865,
                    buildProgress:96.4,
                    quoteProgress:93.25
                },
                {
                    schoolName:"赵海",
                    schoolId:'2',
                    buildNumber:1900,
                    quoteNumber:1765,
                    buildProgress:95,
                    quoteProgress:88.25
                },
                {
                    schoolName:"柯绮莉",
                    schoolId:'3',
                    buildNumber:1720,
                    quoteNumber:1689,
                    buildProgress:86,
                    quoteProgress:84.5
                },
                {
                    schoolName:"沈婉珊",
                    schoolId:'4',
                    buildNumber:1720,
                    quoteNumber:1510,
                    buildProgress:86,
                    quoteProgress:75.5
                },
                {
                    schoolName:"夏沐阳",
                    schoolId:'5',
                    buildNumber:1720,
                    quoteNumber:1510,
                    buildProgress:86,
                    quoteProgress:75.5
                }
            ],
        }
    },
    methods: {
  
        /**
         * @name 跳转更多
         */
        goMore(){
  
        },
    },
    mounted(){
        
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .active-school-rank{
    width: 100%;
    height: 350px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .active-school-rank-top{
        position: relative;
        text-align: center;
        margin-bottom: 20px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .active-school-rank-content{
        height: calc(100% - 60px);
        width: 100%;
        .active-school-rank-content-tips{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 10px;
            .color{
                display: inline-block;
                width: 9px;
                height: 9px;
                border-radius: 2px;
                margin-right: 5px;
            }
            .name{
                margin-right: 30px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6EA0D3;
            }
            .name:last-child(){
                margin-right: 0px;
            }
        }
        .active-school-rank-list{
            .active-school-rank-li{
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                .rank{
                    // margin-left: 10px;
                    font-size: 14px;
                    font-family: DingTalk JinBuTi;
                    font-weight: 400;
                    color: #6EA0D3;
                    // width: 30px;
                    width:50px;
                    padding:0 10px;
                    height: 39px;
                    line-height: 39px;
                    // margin-right: 10px;
                    background-size: 100% 100%;
                    background: url('../../../assets/images/sydataboard/four.png') ;
                }
                .school-name{
                    width: 90px;
                    margin-right: 10px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
                .progress{
                    width: calc(100% - 150px);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 3px 0;
                    flex-direction: column;
                    background: #0E1C51;
                    .top{
                        margin-bottom: 1px;
                    }
                    .top,
                    .bottom{
                        line-height: 16px;
                        display: flex;
                        align-items: center;
                        width: 100%;
                        .rank-progress{
                            width: calc(100% - 50px);
                        }
                        .number{
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #2773E6;
                            max-width: 40px;
                            margin-left: 10px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
            }   
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
  }
  </style>
  <style lang="scss">
  .active-school-rank{
    .active-school-rank-content{
        .active-school-rank-list{
            .active-school-rank-li{
                .progress{
                    .top,
                    .bottom{
                        .el-progress-bar{
                            .el-progress-bar__outer{
                                border-radius: 0;
                                background-color: transparent;
                                .el-progress-bar__inner{
                                    border-radius: 0;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
  </style>